import type { ClockPort, TimerHandle } from './ClockPort.js';

/** Browser adapter: performance.now() for monotonic time, Date.now() for wall. */
export const browserClock: ClockPort = {
  perfNow: () => performance.now(),
  wallNow: () => Date.now(),
  setTimeout: (fn, ms) => globalThis.setTimeout(fn, ms) as unknown as TimerHandle,
  clearTimeout: (h) => globalThis.clearTimeout(h as unknown as number),
};
